import { render, staticRenderFns } from "./modelPlace.vue?vue&type=template&id=0ca81522&scoped=true"
import script from "./modelPlace.vue?vue&type=script&lang=js"
export * from "./modelPlace.vue?vue&type=script&lang=js"
import style0 from "./modelPlace.vue?vue&type=style&index=0&id=0ca81522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca81522",
  null
  
)

export default component.exports